import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xNm9oZThwMCB7CiAgb2JqZWN0LWZpdDogY292ZXI7Cn0';
export var cover = '_16ohe8p0';